var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5806 11.9845L17.5257 19.1487C17.6761 19.3038 17.7953 19.4879 17.8767 19.6905C17.9581 19.8932 18 20.1104 18 20.3297C18 20.549 17.9581 20.7662 17.8767 20.9689C17.7953 21.1715 17.6761 21.3556 17.5257 21.5107C17.3753 21.6658 17.1969 21.7889 17.0004 21.8728C16.804 21.9568 16.5934 22 16.3808 22C16.1681 22 15.9576 21.9568 15.7611 21.8728C15.5647 21.7889 15.3862 21.6658 15.2359 21.5107L6 11.9845L15.2048 2.48927C15.3552 2.33416 15.5337 2.21111 15.7301 2.12716C15.9266 2.04321 16.1371 2 16.3498 2C16.5624 2 16.7729 2.04321 16.9694 2.12716C17.1658 2.21111 17.3443 2.33416 17.4947 2.48927C17.645 2.64436 17.7643 2.82848 17.8457 3.03112C17.9271 3.23376 17.969 3.45096 17.969 3.6703C17.969 3.88965 17.9271 4.10684 17.8457 4.30949C17.7643 4.51213 17.645 4.69625 17.4947 4.85133L10.5806 11.9845Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/Back-Icon.d0fbf11bfb01bf95926e8a0628a051b1.svg";
export { ForwardRef as ReactComponent };